import React from 'react'
import { useTranslation } from 'react-i18next'
import { Trash2 } from 'lucide-react'
import { Button } from '@/src/renderer/components/ui/Button'

interface WhenDropdownFooterProps {
  variant: 'actionbar' | 'badge'
  hasSelection: boolean
  onConfirm: () => void
  onRemove?: () => void
  onClose: () => void
}

export const WhenDropdownFooter: React.FC<WhenDropdownFooterProps> = ({
  variant,
  hasSelection,
  onConfirm,
  onRemove,
  onClose,
}) => {
  const { t } = useTranslation()

  if (!hasSelection && variant !== 'badge') return null

  return (
    <div className="when-dropdown__footer">
      <div className="context-menu-content__separator" />
      <div className="when-dropdown__footer-actions">
        {(variant === 'badge' && onRemove) ? (
          <Button variant="outline" icon={<Trash2 size={16} />} onClick={() => { onClose(); setTimeout(() => onRemove(), 0) }} />
        ) : (
          <div />
        )}
        {hasSelection && (
          <Button
            variant="primary"
            shortcut={{ variant: 'return' }}
            onClick={onConfirm}
          >
            {t('taskCreation.whenConfirm')}
          </Button>
        )}
      </div>
    </div>
  )
}
